import { gql } from '@apollo/client'

export const GET_COOLER_PERFORMANCE_INTERVAL_REPORT = gql`
  query GetCoolerPerformanceIntervalReport(
    $input: AdminDashboardIntervalReportInput!
  ) {
    coolerPerformanceIntervalReport(input: $input) {
      date
      groupId
      value
    }
  }
`
